var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addLink" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "100px",
            size: "small"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "资源分类", prop: "categoryId" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择资源分类" },
                  model: {
                    value: _vm.ruleForm.categoryId,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "categoryId", $$v)
                    },
                    expression: "ruleForm.categoryId"
                  }
                },
                _vm._l(_vm.resourceDatas, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.categoryName, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "链接名称", prop: "linkName" } },
            [
              _c("el-input", {
                attrs: { maxlength: "20", placeholder: "请输入链接名称" },
                model: {
                  value: _vm.ruleForm.linkName,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "linkName", $$v)
                  },
                  expression: "ruleForm.linkName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "链接地址", prop: "linkUrl" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "请输入链接地址" },
                model: {
                  value: _vm.ruleForm.linkUrl,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "linkUrl", $$v)
                  },
                  expression: "ruleForm.linkUrl"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-083ec8ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-083ec8ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/components/addLink.vue
// module id = null
// module chunks = 